import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { SECTORS_PATHS } from '../sectors';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Breadcrumb } from '../../../shared/breadcrumbs/breadcrumbs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-plots-create',
  templateUrl: './sectors-create.component.html',
  styleUrls: ['./sectors-create.component.scss'],
  standalone: false,
})
export class SectorsCreateComponent implements OnInit {
  plotsCreateBreadcrumbs: Breadcrumb[] = [
    { text: 'Участки', url: SECTORS_PATHS.sectors },
    { text: 'Создание участка', url: null },
  ];

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.plotsCreateBreadcrumbs);
  }
}
